// src/pages/cpaCareerQuiz/components/StartPage.jsx
import { motion } from "framer-motion";

export default function StartPage({ onStart }) {
  return (
    <motion.fieldset
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="title">
        <h2>CPA 職涯導航：探索你的專業契合度</h2>
        <p>
          會計專業不只有一種可能。透過 12 題情境測驗，精準分析你的性格傾向與價值觀，
          找到最能發揮你潛力的 CPA 職涯路徑！
        </p>
      </div>

      <div className="mt-4">
        <h4>測驗特色</h4>
        <ul className="mt-3">
          <li>量身打造的職涯分析：針對會計系學生、四大事務所職員及轉職者設計。</li>
          <li>多維度深度評估：從工作型態、風險容忍度到長期價值觀，進行全面剖析。</li>
          <li>對接國際標準：結合專業觀點，讓你了解 CPA 資格如何成為你的國際通行證。</li>
          <li>降低選擇不確定性：協助你判斷更適合分析導向的技術專家，還是商業導向的決策支援者。</li>
        </ul>
      </div>

      <div className="action-buttons mt-5 mb-5 m-auto">
        <button type="button" className="action-button" onClick={onStart}>
          立即開始測驗
        </button>
      </div>
    </motion.fieldset>
  );
}
